import React from 'react';
import Modal from '@material-ui/core/Modal';
import style from './DeleteModal.module.css';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import PropTypes from 'prop-types';

function DeleteModal({ open, handleClose, deleteConfig, result }) {
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
      <div className={style.modalContainer}>
        <h6>
          Are you sure you want to delete{' '}
          <span className={style.name}>{result.configurationName}</span> from
          your saved templates?
        </h6>
        <div className={style.buttons}>
          <TextButton
            fontSize="medium"
            width="100px"
            clickHandler={() => {
              deleteConfig();
              handleClose();
            }}
            color="white"
            backgroundColor="red"
          >
            Delete
          </TextButton>
          <TextButton
            fontSize="medium"
            width="100px"
            clickHandler={handleClose}
            color="white"
            backgroundColor="blue"
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
}
DeleteModal.propTypes = {
  configName: PropTypes.string,
  deleteConfig: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  result: PropTypes.any,
  updateConfig: PropTypes.func,
};

export default DeleteModal;
